export default __webpack_public_path__ + "static/media/apr.4b121489.pdf";